import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=7317f92b&"
import script from "./OpenQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports